import request, { BASE_URL, BASE_URL2 } from '@/utils/request'
// import getObj from './func.js'

/**
 * 主要 API 接口
 */
const main = {
    /**
     * 搜索记录
     * @param {Object} data - 搜索参数
     * @returns {Promise} 请求结果
     */
    searchRecords(data) {
        return request.post(`${BASE_URL}/list?include_base_fields`, data)
    },
    /**
     * 搜索记录
     * @param {Object} data - 搜索参数
     * @returns {Promise} 请求结果
     */
    searchRecords2(data) {
        return request.post(`${BASE_URL2}/list?include_base_fields`, data)
    },
    /**
     * 获取单条记录
     * @param {Object} data - { schema_id, record_id }
     * @returns {Promise} 请求结果
     */
    getRecord(data) {
        return request.post(`${BASE_URL}/get?include_base_fields`, data)
    },
    /**
     * 搜索记录
     * @param {Object} data - 搜索参数
     * @returns {Promise} 请求结果
     */
    searchAnalysableRecords(data) {
        return request.post(`${BASE_URL}/analysable/list?include_base_fields`, data)
    },
    /**
     * 创建记录
     * @param {Object} data - 记录数据
     * @returns {Promise} 请求结果
     */
    createRecord(data) {
        return request.post(`${BASE_URL}/create`, data)
    },
    /**
     * 更新记录
     * @param {Object} data - 记录数据
     * @returns {Promise} 请求结果
     */
    updateRecord(data) {
        return request.post(`${BASE_URL}/update`, data)
    },
    /**
     * 触发数据流
     * @param {Object} data - 数据流数据
     * @returns {Promise} 请求结果
     */
    triggerDataflow(data) { 
        return request.post(`${BASE_URL}/dataflow/${data.dataflow_id}/run?record_id=${data.record_id}`, data)
    },
    /**
     * 获取文件（如图片）真实url
     * @param {Object} data - { type: 'images', name: 文件名 }
     * @returns {Promise} 请求结果
     */
    get_file(data) {
        return request.post(`${BASE_URL}/get_file`, { data })
    }
}

export default main
